<template>
  <m-dialog ref="dlg" :btnsave="false" :title="user && user.id ? 'Ubah Pengguna' : 'Tambah Pengguna'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-card flat text v-if="step == 1" class="mt-4 px-2">
          <v-form autocomplete="false" data-vv-scope="form" lazy-validation>
            <v-row wrap class="ma-5 pt-5">
              <v-col cols="12">
                <m-alert
                  show
                  :title="alert.pengguna.form.judul"
                  :info="alert.pengguna.form.deskripsi"
                  closable
                ></m-alert>
              </v-col>
              <v-col cols="12" sm="12" md="10" lg="10" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  autocomplete="false"
                  name="Alamat Surel"
                  placeholder="Masukkan alamat surel yang akan ditambahkan"
                  label="Surel"
                  v-model="user.email"
                  persistent-hint
                  @keyup.enter="cek"
                  data-vv-name="email"
                  data-vv-as="Surel"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('form.email')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2" lg="2" class="my-0">
                <m-button
                  depressed
                  isBlock
                  class="text-capitalize"
                  textButton="Cari"
                  icon="mdi-magnify"
                  action="cek"
                  @cek="cek"
                ></m-button>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-card flat text v-else-if="step == 2" class="mt-4 pb-5">
          <v-card-text class="mb-0 pb-0">
            <v-form data-vv-scope="form" lazy-validation class="ma-5">
              <v-row wrap>
                <v-col cols="12" class="mb-4">
                  <m-alert
                    show
                    :title="alert.pengguna.form2.judul"
                    :info="alert.pengguna.form2.deskripsi"
                    closable
                  ></m-alert>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-text-field
                    autofocus
                    dense
                    autocomplete="false"
                    outlined
                    label="Nama lengkap"
                    v-model="user.name"
                    placeholder="Masukkan Nama Lengkap Anggota"
                    data-vv-name="nama"
                    data-vv-as="Nama Lengkap"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.nama')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-text-field
                    dense
                    autocomplete="false"
                    outlined
                    readonly
                    label="Surel"
                    v-model="user.email"
                    placeholder="Masukkan Surel"
                    data-vv-name="email"
                    data-vv-as="Surel"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('form.email')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2" v-if="!user.id">
                  <v-text-field
                    dense
                    autocomplete="false"
                    outlined
                    placeholder="Kata Sandi"
                    :append-icon="appendIcon"
                    @click:append="switchVisibility"
                    ref="password"
                    :type="passwordFieldType"
                    label="Kata Sandi"
                    v-model="user.password"
                    data-vv-name="password"
                    data-vv-as="Kata Sandi"
                    v-validate="'required|min:6'"
                    :error-messages="errors.collect('form.password')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2" v-if="!user.id">
                  <v-text-field
                    dense
                    autocomplete="false"
                    outlined
                    placeholder="Konfirmasi Kata Sandi"
                    type="password"
                    label="Konfirmasi Kata Sandi"
                    v-model="user.password_confirmation"
                    data-vv-name="password_confirmation"
                    data-vv-as="Konfirmasi Kata Sandi"
                    v-validate="'required|min:6|confirmed:password'"
                    :error-messages="errors.collect('form.password_confirmation')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-autocomplete
                    outlined
                    dense
                    autocomplete="false"
                    v-model="tingkat"
                    :items="itemTingkats"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Tingkat"
                    label="Untuk Tingkat"
                    name="Tingkat"
                    item-value="id"
                    return-object
                    item-text="keterangan2"
                    data-vv-name="tingkat"
                    data-vv-as="Tingkat"
                    v-validate="''"
                    :error-messages="errors.collect('form.tingkat')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-select
                    dense
                    autocomplete="false"
                    outlined
                    :items="itemPerans"
                    item-text="keterangan"
                    item-value="id"
                    data-vv-name="peran"
                    data-vv-as="Peran"
                    placeholder="Peran"
                    multiple
                    v-model="user.peran"
                    return-object
                    v-validate="''"
                    label="Hak Akses"
                    :error-messages="errors.collect('form.peran')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                  <v-select
                    dense
                    autocomplete="false"
                    outlined
                    :items="itemKategories"
                    item-text="keterangan"
                    item-value="id"
                    data-vv-name="kategori"
                    data-vv-as="Kategori"
                    hint="Kategori"
                    multiple
                    v-model="user.grup"
                    return-object
                    v-validate="'required'"
                    label="Kategori"
                    :error-messages="errors.collect('form.kategori')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pt-5 my-5 mx-0 px-0">
            <m-button right absolute textButton="Simpan" icon="mdi-content-save" action="save" @save="save"></m-button>
          </v-card-actions>
        </v-card>

        <v-card flat text v-else class="mt-4">
          <v-card-text class="pa-0 mt-5">
            <v-form data-vv-scope="form" lazy-validation>
              <v-row wrap>
                <v-col cols="12">
                  <m-alert
                    show
                    title="Info"
                    :info="
                      `Surel ` +
                        user.email +
                        ` telah terdaftar atas nama ` +
                        user.name +
                        ` jika Anda ingin menambahkan ke Instansi Anda silahkan pilih peran dan tekan tombol simpan`
                    "
                    closable
                  ></m-alert>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-text-field
                    autofocus
                    dense
                    autocomplete="false"
                    outlined
                    readonly
                    label="Nama lengkap"
                    v-model="user.name"
                    placeholder="Masukkan Nama Lengkap Anggota"
                    data-vv-name="nama"
                    data-vv-as="Nama Lengkap"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.nama')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-text-field
                    dense
                    autocomplete="false"
                    outlined
                    readonly
                    label="Surel"
                    v-model="user.email"
                    placeholder="Masukkan Surel"
                    data-vv-name="email"
                    data-vv-as="Surel"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('form.email')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-autocomplete
                    outlined
                    dense
                    autocomplete="false"
                    v-model="tingkat"
                    :items="itemTingkats"
                    no-data-text="Data Tidak Tersedia"
                    placeholder="Pilih Tingkat"
                    label="Untuk Tingkat"
                    name="Tingkat"
                    item-value="id"
                    return-object
                    item-text="keterangan2"
                    data-vv-name="tingkat"
                    data-vv-as="Tingkat"
                    v-validate="''"
                    :error-messages="errors.collect('form.tingkat')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-2">
                  <v-select
                    dense
                    autocomplete="false"
                    outlined
                    :items="itemPerans"
                    item-text="keterangan"
                    item-value="id"
                    data-vv-name="akses"
                    data-vv-as="Akses"
                    placeholder="Akses"
                    v-model="user.peran"
                    return-object
                    v-validate="''"
                    label="Hak Akses"
                    :error-messages="errors.collect('form.akses')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                  <v-select
                    dense
                    autocomplete="false"
                    outlined
                    :items="itemKategories"
                    item-text="keterangan"
                    item-value="id"
                    data-vv-name="kategori"
                    data-vv-as="Kategori"
                    hint="Kategori"
                    multiple
                    v-model="user.grup"
                    return-object
                    v-validate="'required'"
                    label="Kategori"
                    :error-messages="errors.collect('form.kategori')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-0">
            <m-button isBlock textButton="Simpan" icon="mdi-content-save" action="save" @save="save"></m-button>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
import { KELAMIN } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      alert: ALERT_INFO,
      user: {},
      step: 1,
      tingkat: null,
      appendIcon: "mdi-eye-off",
      passwordFieldType: "password",
      defUser: {
        nama: null,
        email: "",
        no_hp: "62",
        kelamin: "L",
        perans: [],
        tingkat: []
      },
      KELAMIN: KELAMIN,
      itemPerans: [],
      itemTingkats: [],
      itemKategories: [
        {
          id: 1,
          keterangan: "Pengajar"
        },
        {
          id: 2,
          keterangan: "Peserta"
        }
      ]
    };
  },
  methods: {
    open(obj) {
      this.loadPeran();
      this.loadTingkat();

      if (obj) {
        this.user = obj;
        (this.tingkat = obj.tingkat[0]), (this.step = 2);
      } else {
        (this.tingkat = {}), (this.step = 1);
      }

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    // eslint-disable-next-line
    loadPeran() {
      return this.$store
        .dispatch("user/getPeran", this.instansi_id)
        .then(res => {
          return (this.itemPerans = res.data);
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    loadTingkat() {
      return this.$store
        .dispatch("tingkat/get", {
          instansi_id: this.instansi_id,
          params: {}
        })
        .then(res => {
          return (this.itemTingkats = res);
        })
        .catch(e => e);
    },

    cek() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("user/checkAvailable", {
              instansi_id: this.instansi_id,
              params: {
                email: this.user.email
              }
            })
            .then(res => {
              if (res.id) {
                this.step = 3;
                this.user = res;
                this.user.peran = [];
              } else {
                this.step = 2;
              }
            });
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
      this.passwordFieldType === "password" ? (this.appendIcon = "mdi-eye-off") : (this.appendIcon = "mdi-eye");
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          // this.user.tingkat[0] = this.tingkat;
          return this.$store.dispatch("user/create", {
            instansi_id: this.instansi_id,
            obj: this.user
          });
        })
        .then(res => {
          this.$info("Simpan Data Berhasil");
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
